import React, { useCallback, useMemo } from 'react';

import { Form } from 'react-final-form';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import { FORM_ERROR } from 'final-form';

import verificationBGImage from '../../assets/images/amazon/verificationBGImage.png';
import TenantConfig from '../../config';

/** helpers */
import { composeValidators, max, min, password, required } from '../../helpers/validation';

/** components */
import { FormInput } from '../FormElements';

const NewPassword = ({ onSubmit, className }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const formOptions = useMemo(() => {
    return {
      fields: [
        {
          label: 'Password',
          placeholder: 'Enter your password',
          required: true,
          type: 'password',
          validate: composeValidators(
            required("Password can't be empty"),
            min('Password must be at least 8 characters long', 8),
            password('Must have 8 characters, uppercase & lowercase letters, one number'),
            max('Maximum length is 64 characters', 64)
          ),
          name: 'password',
        },
        {
          label: 'Confirm Password',
          placeholder: 'Enter your password',
          required: true,
          type: 'password',
          validate: composeValidators(
            required('You must confirm password'),
            max('Maximum length is 64 characters', 64)
          ),
          name: 'confirmpassword',
        },
      ],
    };
  }, []);

  const onSubmitInternal = useCallback(
    async (values) => {
      try {
        await onSubmit(values);
        navigate('/auth/sign-in' + location.search);
      } catch (err) {
        return { [FORM_ERROR]: 'Password change failed' };
      }
    },
    [navigate, location, onSubmit]
  );

  return (
    <>
      {className === 'admin' && (
        <div className="logo-wrapper">
          <img className="logo" src={TenantConfig.headerLogo} alt="logo" />
        </div>
      )}
      <div
        className={`${
          className === 'admin' ? 'admin-form topoffset-newpassword' : className
        } section`}
      >
        <div className={`${className}-header`}>
          <h1>{className === 'admin' ? 'New Password' : 'Enter New Password'}</h1>
        </div>
        <div className={`${className}-main`}>
          <Form
            onSubmit={onSubmitInternal}
            validate={(values) => {
              const errors = {};
              if (values.password && values.confirmpassword !== values.password) {
                errors.confirmpassword = 'Passwords must match';
              }
              return errors;
            }}
            initialValues={{
              phone: '+1-___-___-___',
            }}
            render={({ handleSubmit, form, submitting, pristine, submitError }) => (
              <form onSubmit={handleSubmit} className="form">
                {formOptions.fields.map((f) => {
                  return className === 'admin' ? (
                    <div className={`admin-form__${f.name}`} key={`form_${f.name}`}>
                      <FormInput {...f} />
                    </div>
                  ) : (
                    <FormInput {...f} key={`form_${f.name}`} />
                  );
                })}
                <button className="btn primary-btn" type="submit" disabled={submitting || pristine}>
                  Save password
                </button>
                {submitError && <p className="error-text">{submitError}</p>}
              </form>
            )}
          />
        </div>
        <p className="subtitle">
          {className === 'admin' ? (
            <small>
              Already have an account? <Link to={`/auth/register?app=/${className}`}>Sign up</Link>
            </small>
          ) : (
            <small>
              <Link to="/auth/register">Don't have an account yet? Please sign up!</Link>
            </small>
          )}
        </p>
      </div>
      {TenantConfig?.auth.renderBottomImg && className !== 'admin' && (
        <img
          className="phone-verification-bg"
          src={verificationBGImage}
          alt="Verification Background Image"
        />
      )}
    </>
  );
};

export default NewPassword;
